import './verticalSeparator.scss';

const VerticalSeparator = () => {
  return <div className="vertical-separator-component"></div>;
};

export default VerticalSeparator;
